import { Checkbox } from "@volca/ui/components/ui/checkbox";
import { Label } from "@volca/ui/components/ui/label";
import { Stack } from "@volca/ui/components/ui/stack";
import { Text } from "@volca/ui/components/ui/text";
import { cn } from "@volca/ui/lib/utils";

interface OptionCheckboxProps {
  id: string;
  label: string;
  hint?: string;
  checked: boolean;
  disabled?: boolean;
  onCheckedChange: (checked: boolean) => void;
}

// CheckboxWithLabel uses larger text than this drawer.
export const OptionCheckbox = ({
  id,
  label,
  hint,
  checked,
  disabled,
  onCheckedChange,
}: OptionCheckboxProps) => (
  <Stack direction="row" gap={2} align="start">
    <Checkbox
      id={id}
      checked={checked}
      disabled={disabled}
      aria-describedby={hint ? `${id}-hint` : undefined}
      className="mt-0.5"
      onCheckedChange={(value) => onCheckedChange(value)}
    />
    <Stack align="start" gap={0}>
      <Label
        htmlFor={id}
        className={cn("cursor-pointer text-sm font-normal", {
          "text-ink": !disabled,
          "text-subtle": disabled,
        })}
      >
        {label}
      </Label>
      {hint && (
        <Text id={`${id}-hint`} variant="caption" tone="muted">
          {hint}
        </Text>
      )}
    </Stack>
  </Stack>
);
